import { jsxs as k, jsx as v } from "react/jsx-runtime";
import { forwardRef as T, useRef as w, useImperativeHandle as y, useEffect as A } from "react";
import E from "../builders-icons/dist/systems/external-link.js";
import { useTracking as L, getText as R } from "../utils.js";
import c from "./link.module.css.js";
import j from "clsx/lite";
const N = {
  no: "Åpner i nytt vindu",
  da: "Åbner i nyt vindue",
  se: "Öppnas i nytt fönster",
  en: "Opens in new window"
}, $ = T(function({
  as: l,
  children: u,
  className: m,
  icon: p = "auto",
  onClick: r,
  tracking: g = !0,
  ...e
}, f) {
  const d = l || "a", a = w(null), n = e.target === "_blank", b = L(g), x = (t) => {
    b({
      eventCategory: "link",
      eventAction: "click",
      eventLabel: R(t.currentTarget)
    }), r == null || r(t);
  };
  return y(f, () => a.current), A(() => {
    var s;
    const t = a.current, i = n && ((s = t == null ? void 0 : t.closest("[lang]")) == null ? void 0 : s.getAttribute("lang")), o = N[i];
    return o ? t == null || t.setAttribute("aria-description", o) : n && console.warn(`Invalid page language "${i}"`), () => t == null ? void 0 : t.removeAttribute("aria-description");
  }, [n]), e.target === "_blank" && Object.assign(e, { rel: "noreferrer noopener" }), /* @__PURE__ */ k(
    d,
    {
      className: j(c.link, m),
      onClick: x,
      ref: a,
      ...e,
      children: [
        u,
        n && p && /* @__PURE__ */ v(E, { className: c.external })
      ]
    }
  );
});
export {
  $ as Link
};
//# sourceMappingURL=link.js.map
